import React from "react";
import SEO from "../components/SEO";

export default function AboutPage() {
  return (
    <div className="container my-5">
      <SEO
        title="About 100Eyes Technologies LLP | Leading IT & Software Development Company"
        description="100Eyes Technologies LLP is a Delhi-based IT and software development company specializing in enterprise solutions, web & mobile apps, AI automation, and cloud transformation. We help startups and enterprises scale through smart digital innovation."
  canonical="https://100eyestechnologies.com/about-us"
  openGraph={{ image: 'https://100eyestechnologies.com/img/about-banner.webp' }}
      >
        <meta
          name="keywords"
          content="100Eyes Technologies, software development company, web app development, mobile app development, AI automation, cloud computing, digital transformation, IT services India, enterprise software solutions"
        />
        <meta name="author" content="100Eyes Technologies LLP" />
      </SEO>

  <h1 className="mb-4">About 100Eyes Technologies LLP</h1>
      <p>
  <strong>100Eyes Technologies LLP</strong> is a leading, MSME-certified IT solutions provider based in Delhi, India.
        With over a decade of expertise in technology, we have successfully delivered innovative and scalable software
        applications across industries such as healthcare, education, e-commerce, fintech, and manufacturing. Our
        mission is simple — to empower businesses with smart, secure, and sustainable technology solutions that drive
        measurable growth.
      </p>

      <p>
        We specialize in developing custom <strong>web and mobile applications</strong>, modern <strong>cloud architectures</strong>,
        and AI-driven platforms that help organizations digitize their workflows and deliver superior customer experiences.
        Our team of passionate developers, designers, and analysts work closely with clients to turn ideas into impactful
        business solutions that are ready for scale.
      </p>

      <h3 className="mt-5">Our Mission</h3>
      <p>
        To deliver reliable, future-ready, and innovative software solutions that empower businesses to grow, compete,
        and lead in the digital era. At 100Eyes, we believe in using technology as a force for progress — creating systems
        that simplify processes, enhance productivity, and ensure long-term value.
      </p>

      <h3 className="mt-4">Our Vision</h3>
      <p>
        To become a global leader in digital transformation by combining human creativity with cutting-edge technologies.
        We envision a world where every business — from startups to enterprises — can leverage digital intelligence to achieve
        exceptional success.
      </p>

      <h3 className="mt-4">Our Core Values</h3>
      <ul>
        <li>
          <strong>Customer First:</strong> Every solution we build starts with understanding our clients' goals and challenges.
        </li>
        <li>
          <strong>Quality Driven:</strong> We maintain global standards and best practices across design, code, and delivery.
        </li>
        <li>
          <strong>Innovation Centric:</strong> We constantly explore new technologies like AI, ML, and IoT to create smarter systems.
        </li>
        <li>
          <strong>Continuous Improvement:</strong> From process optimization to skill enhancement, we believe learning never stops.
        </li>
        <li>
          <strong>Integrity & Transparency:</strong> We build lasting relationships through trust and ethical collaboration.
        </li>
      </ul>

      <h3 className="mt-4">Why Choose 100Eyes Technologies?</h3>
      <p>
        Choosing <strong>100Eyes Technologies</strong> means partnering with a team that's dedicated to your long-term success.
        We don't just deliver code — we deliver outcomes. Our agile approach ensures that every project is flexible,
        scalable, and aligned with your business goals. Whether you're building a startup MVP or scaling an enterprise
        system, our experts are ready to deliver excellence at every step.
      </p>

      <p className="mt-4">
        Explore how we can help your business grow. <a href="/contact-us">Contact our team</a> today to discuss your project
        and discover the right digital solution for your vision.
      </p>
      
      <p className="mt-3">
        For best practices on web performance and search-friendly markup, we follow guidance from trusted sources such as
        <a href="https://developer.mozilla.org/en-US/docs/Web/Performance" target="_blank" rel="noopener noreferrer"> MDN Web Performance</a> and the
        <a href="https://developers.google.com/search/docs/beginner/seo-starter-guide" target="_blank" rel="noopener noreferrer"> Google SEO Starter Guide</a>.
      </p>
    </div>
  );
}
